export const images = {
  heroBackground: '/img/bg-image.jpg',
  profile: '/img/profile.jpg',
  profileSidebar: '/img/profile.jpg',
  profileAbout: '/img/profile.jpg',
  signInBackground: '/img/bg-l.jpg',
  resumeId: '/img/profile.jpg',
  resumeBreak: '/img/break.png',
  pending: '/img/pending.png',
  portfolioAndroid: '/img/portfolio/android.png',
  portfolioZip: '/img/portfolio/file-zip.png',
  ourmoment: '/img/products/ourmoment-logo.svg',
  ourmomentDark: '/img/products/ourmoment-logo-dark.svg',
  localstalls: '/img/products/localstalls-logo.svg',
  siteconx: '/img/products/siteconx-logo.png',
}
